import React from 'react';
import {
  Router as DefaultRouter,
  Route,
  Switch,
  StaticRouter,
} from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@@/history';
import { routerRedux } from 'dva';

const Router = routerRedux.ConnectedRouter;

const routes = [
  {
    path: '/',
    component: require('../../layouts/index').default,
    routes: [
      {
        path: '/',
        component: require('../home').default,
        showMenu: true,
        exact: true,
      },
      {
        path: '/movieDetail',
        component: require('../movieDetail/index').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/cinema',
        component: require('../cinema/index').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/cinemaDetail',
        component: require('../cinemaDetail/index').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/movieSeat',
        component: require('../movieSeat/index').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/map',
        component: require('../map/index').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/order/confirm',
        component: require('../order/confirm/index').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/orders',
        component: require('../order/list/index').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/order/status',
        component: require('../order/status/index').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/movieListDetail',
        component: require('../movieList/checkLoading').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/movieList',
        component: require('../movieList/index').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/payResult/succ',
        component: require('../payResult/succ').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/applyRefund',
        component: require('../applyRefund/index').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/applyRefundDetail',
        component: require('../applyRefundDetail/index').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/refundExplain',
        component: require('../refundExplain/index').default,
        showMenu: false,
        exact: true,
      },
      {
        path: '/*',
        component: require('../notFound/index').default,
        showMenu: false,
        exact: true,
      },
    ],
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    // dva 中 history.listen 会初始执行一次
    // 这里排除掉 dva 的场景，可以避免 onRouteChange 在启用 dva 后的初始加载时被多执行一次
    const isDva =
      history.listen
        .toString()
        .indexOf('callback(history.location, history.action)') > -1;
    if (!isDva) {
      routeChangeHandler(history.location);
    }
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return <Router history={history}>{renderRoutes(routes, props)}</Router>;
  }
}
